import { gql } from "@apollo/client";

export const TOTAL_CLAIM_BALANCE_NO_PAID = gql`
    query TotalOrderGroupClaimBalance($where: claimBalanceOrderGroupInput) {
        totalOrderGroupClaimBalance(where: $where) {
            no_paid {
                total
            }
            invalidPaid {
                total
            }
            noticeNoPaid {
                total
            }
            waitingConfirm {
                total
            }
            claimBalance {
                total
            }
            notClaimBalance {
                total
            }
            printOrder {
                total
            }
            userConfirm {
                total
            }
        }
    }
`;